import React from "react";
import { links } from "../data";

export default function Footer() {
    return (
        <section id="footer">
            {/* <footer>
                <div class="footerComtainer">
                {links.map((link) => (
                    <div class="footerLink">
                        <a href={link.link}>{link.title}</a>
                    </div>
                ))}
                </div>
            </footer> */}
        </section>
    );
}


// WEBPACK FOOTER //
// ./src/components/Footer.js